var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lets-icons:check-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 3C10.9193 3 11.8294 3.18142 12.6787 3.5332C13.528 3.88499 14.3002 4.39981 14.9502 5.0498C15.6002 5.6998 16.115 6.47204 16.4668 7.32129C16.8186 8.17057 17 9.08075 17 10C17 10.9193 16.8186 11.8294 16.4668 12.6787C16.115 13.528 15.6002 14.3002 14.9502 14.9502C14.3002 15.6002 13.528 16.115 12.6787 16.4668C11.8294 16.8186 10.9193 17 10 17C8.14349 17 6.36256 16.2629 5.0498 14.9502C3.73705 13.6374 3 11.8565 3 10C3 8.14348 3.73705 6.36256 5.0498 5.0498C6.36256 3.73705 8.14348 3 10 3ZM12.3096 6.64648L9.07617 10.5244L7.25586 8.7041L6.90234 9.05762L5.72363 10.2354L5.37012 10.5889L9.25586 14.4746L9.60645 14.0547L10.1904 13.3535L14.3574 8.35352L14.6777 7.96973L14.293 7.64941L13.0137 6.58301L12.6289 6.2627L12.3096 6.64648Z",
    fill: "#F7F7FF",
    stroke: "#F7F7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFill);
export default __webpack_public_path__ + "static/media/check-fill.504dfe2d168ad9a2a6f15186e1405398.svg";
export { ForwardRef as ReactComponent };